import { HOURS, SERVICES } from "../data/site";

const ITEMS = [
  `Çalışma Saatleri: Her Gün ${HOURS}`,
  ...SERVICES.map((s) => s.name),
  "Sivas'ta Huzur ve Yenilenmenin Adresi",
  "Kendinize İyi Gelin",
  "Bizi Google'da Değerlendirin",
  "Rahatlamak Bir Lüks Değil, Kendinize Verdiğiniz Sözdür",
];

export default function Ticker() {
  return (
    <div className="ticker" data-testid="info-ticker">
      <span className="ticker-label">Lunessa</span>
      <div className="ticker-window" aria-hidden="true">
        <div className="ticker-track">
          {[0, 1].map((half) => (
            <div className="ticker-half" key={half}>
              {ITEMS.map((item, i) => (
                <span key={`${half}-${i}`}>
                  {item} <i>✦</i>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
